export default "__VITE_ASSET__33a89b1f__"